import { Env } from '../Interfaces';
var Config = /** @class */ (function () {
    function Config() {
    }
    Config.isProdEnv = function (env) {
        return env === Env['prod-us'] || env === Env['prod-apac'] || env === Env['prod-eu'];
    };
    Config.getBasePaymentUrl = function (env) {
        switch (env) {
            case Env['prod-us']:
                return 'https://us.public.payments.fast.asurion.com/v1';
            case Env['prod-apac']:
                return 'https://ap.public.payments.fast.asurion.com/v1';
            case Env['prod-eu']:
                return 'https://eu.public.payments.fast.asurion.com/v1';
            case Env['qa-us']:
                return 'https://us.public.payments.npr.fast.asurion.com/qa';
            case Env['qa-apac']:
                return 'https://ap.public.payments.npr.fast.asurion.com/qa';
            case Env['qa-eu']:
                return 'https://eu.public.payments.npr.fast.asurion.com/qa';
            case Env.dev:
                return 'https://us.public.payments.npr.fast.asurion.com/dev';
            case Env.local:
                return 'http://localhost:3000/v3';
            case Env['local-epaper']:
                return 'http://localhost:8001/bgw';
            case Env['dev-epaper']:
                return 'https://dev.epaper.pci.npr.aws.asurion.net/api/bgw';
            case Env['qa-epaper']:
                return 'https://qa.epaper.pci.npr.aws.asurion.net/api/bgw';
            case Env['uat-epaper']:
                return 'https://uat.epaper.pci.npr.aws.asurion.net/api/bgw';
            case Env['staging-epaper']:
                return 'https://staging.epaper.asurion53.com/api/bgw';
            case Env['prod-epaper']:
                return 'https://epaper.asurion53.com/api/bgw';
            default:
                return 'http://fakeUrl';
        }
    };
    Config.defaultTimeout = 30000; // 30 seconds
    Config.defaultVendorTimeout = 15000; // 15 seconds
    return Config;
}());
export { Config };
